import styles from './TrackingNavigationBar.module.css';

function TrackingNavigationBar({
  vehicle,
  onClose
}) {
  if (!vehicle) {
    return null;
  }

  const lat =
    vehicle.lat ??
    vehicle.latitude;

  const lng =
    vehicle.lng ??
    vehicle.longitude;

  const latitude = Number(lat);
  const longitude = Number(lng);

  const hasLocation =
    lat != null &&
    lng != null &&
    !Number.isNaN(latitude) &&
    !Number.isNaN(longitude) &&
    latitude !== 0 &&
    longitude !== 0;

  const openGoogleMaps = () => {
    if (!hasLocation) return;

    const destination =
      `${latitude},${longitude}`;

    const url =
      `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
        destination
      )}&travelmode=driving`;

onClose?.();

window.location.assign(url);
  };

  const openWaze = () => {
    if (!hasLocation) return;

    const url =
      `https://waze.com/ul?ll=${latitude},${longitude}&navigate=yes`;

onClose?.();

window.location.assign(url);
  };

  return (
    <div className={styles.bar}>
      <div className={styles.iconBox}>
        <svg
          width="21"
          height="21"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M5 19c3.4-1.2 4.7-3.1 4.7-5.4 0-2.1-1.1-3.1-1.1-5.1C8.6 5.7 10.7 4 13 4c3 0 5.4 2.4 5.4 5.4 0 4.1-4.4 7.7-6.4 9.1"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />

          <circle
            cx="5"
            cy="19"
            r="2"
            fill="currentColor"
          />

          <circle
            cx="13"
            cy="4"
            r="2"
            fill="currentColor"
          />
        </svg>
      </div>

      <div className={styles.content}>
     <div className={styles.title}>
  ¿Quieres ir hasta {vehicle.name || 'tu activo'}?
</div>

        {!hasLocation ? (
          <div className={styles.noLocation}>
            El activo no tiene una ubicación GPS disponible.
          </div>
        ) : (
          <div className={styles.actions}>
            <button
              type="button"
              className={styles.navigationButton}
              onClick={openGoogleMaps}
            >
              Google Maps
            </button>

            <button
              type="button"
              className={styles.navigationButton}
              onClick={openWaze}
            >
              Waze
            </button>
          </div>
        )}
      </div>

      <button
        type="button"
        className={styles.closeButton}
        onClick={onClose}
        aria-label="Cerrar navegación"
      >
        ×
      </button>
    </div>
  );
}

export default TrackingNavigationBar;